import { ISection } from './entity/type';
import Design from './assets/Design.svg';
import Engineer from './assets/Engineer.svg';
import Product from './assets/Product.svg';
import Career from './assets/Career.svg';

import dino from './assets/profile/dino.png';
import soo from './assets/profile/soo.png';
import ezi from './assets/profile/ezi.png';
import harry from './assets/profile/harry.png';
import gyuni from './assets/profile/gyuni.png';
import joeum from './assets/profile/joeum.png';
import blanc from './assets/profile/blanc.png';
import minny from './assets/profile/minny.png';
import peter from './assets/profile/peter.png';
import mint from './assets/profile/mint.png';
import andrew from './assets/profile/andrew.png';
import ashley from './assets/profile/ashley.png';

/* thumbnailImage */
import Career_Andrew from './assets/thumbnail/Career_Andrew.jpg';
import Career_Ashley from './assets/thumbnail/Career_Ashley.jpg';
import Career_Mint from './assets/thumbnail/Career_Mint.jpg';
import Design_Blanc from './assets/thumbnail/Design_Blanc.jpg';
import Design_Minny from './assets/thumbnail/Design_Minny.jpg';
import Design_Soo from './assets/thumbnail/Design_Soo.jpg';
import Engineer_EziGyuni from './assets/thumbnail/Engineer_EziGyuni.jpg';
import Engineer_Harry from './assets/thumbnail/Engineer_Harry.jpg';
import Engineer_Peter from './assets/thumbnail/Engineer_Peter.jpg';
import Product_Dino from './assets/thumbnail/Product_Dino.jpg';
import Product_Joeum from './assets/thumbnail/Product_Joeum.jpg';

import Github from './assets/github.png'
import YOURSSU from './assets/Logo.png'
import PPUSSUNG from './assets/ppussung.png'

const List: ISection[] = [
  {
    icon: '🎨',
    name: 'Design',
    id: 'Design',
    title: ['유어슈', '디자이너', '의 고민들'],
    description: '유어슈는 재미있는 캠퍼스 라이프를 위해 학생들을 만나 그들의 문제를 파악하고, 빠르게 문제를 해결하고자 노력하고 있습니다. 유어슈 디자이너의 접근 방법과 고민 과정, 그리고 그 결과물을 공유합니다.',
    color: '#E73564',
    date: null,
    iconUrl: Design,
    sessions: [
      {
        title: '재미있는 학교를 위해 ‘Fun, Cool, Sexy’해질 우리',
        speakers: [{
          name: '고광서',
          job: 'Product Designer',
          image: blanc,
          email: 'blanc.urssu@gmail.com',
        }],
        description:
          '숭실대 캠퍼스 라이프의 문제를 ‘재미’ 라는 간단하고 핵심적인 주제로 접근하며, 아무렇지 않은 것 처럼 멋지게, 즉 ‘Fun, Cool, Sexy’ 한 방향성인 “숨쉴때” 브랜딩을 제시합니다. 이 장난 같은 브랜딩이 어떻게 설계되었는지에 대한 내용과 유어슈라는 커뮤니티 팀에서 ‘재미’가 ‘프로페셔널’과 어떻게 연결 될 수 있는지 알아봅니다. 그리고 이러한 브랜딩이 팀에 끼치는 중요도가 어느정도인지 인사이트를 공유하려 합니다.\n\n*세션 대상 : 작은 팀 혹은 동아리의 정체성과 대내외에 컨셉 및 테마를 정하여 운영하는 시도를 원하시는 분. 팀 브랜딩과 제품 브랜딩이 어떻게 결정되는지 궁금하신 분.',
        youtubeURL: 'https://www.youtube.com/embed/bw568DHE7fM',
        thumbnailImage: Design_Blanc,
      },
      {
        title: '숭실대학교 학생의 경험, 그 속에서 기회찾기',
        speakers: [{
          name: '권현민',
          job: 'Ex Design Leader',
          image: minny,
          email: 'minny.urssu@gmail.com',
        }],
        description:
          "IT/인터넷 업계에서 UX의 중요성은 날이 갈수록 중요해지고 있습니다.\n유어슈 디자인팀 역시 숭실대학교 학생들에게 어떤 서비스를 제공할지에 대해 UX 측면의 설계 및 개선을 진행 중입니다.\n이 세션에서는 UX 구상을 위한 “경험의 3차원 모형” 이론과 각각의 실제 예시를 들어가면서 설명합니다. 그리고 이 이론을 활용해 최근에 입학한 숭실대학교 학생들을 대상으로 하는 UX를 도출해보는 예시를 제공합니다.\n\n*세션 대상 : 학생 레벨에서 소프트웨어 디자인을 진행할 때 어떻게 UX 측면의 문제 해결을 진행해볼지 고민하시는 분. UX적 접근이 어떤 것인지 배워보고 싶은 예비 디자이너",
        youtubeURL: 'https://www.youtube.com/embed/RwLLjhb3-iE',
        thumbnailImage: Design_Minny,
      },
      {
        title: 'YDS로 사용성 높은 디자인하는 법',
        speakers: [{
          name: '박수현',
          job: 'Product Designer',
          image: soo,
          email: 'soo.urssu@gmail.com',
        }],
        description:
          '다수의 유저를 대상으로하는 IT / 인터넷 서비스들이 “디자인 언어” 라고 불리우는 디자인 시스템을 각각의 목적을 가지고 탄생되고있으며 많은 논의가 일어나고 있습니다.\n유어슈 역시 서비스를 제작하는 주체인 디자인, 개발팀이 “Yourssu Design System(이하 YDS)” 이라는 규약을 설정하고 각 팀에서 이를 설계 및 구현하여 서비스를 만들어 나가고 있습니다.\n이 세션에서는 YDS의 존재 의의, 구성 요소, 그리고 앞으로의 발전 방향등을 공유하며 캠퍼스 커뮤니티 서비스를 위한 디자인 언어가 무엇이고 어떤 효과를 제공하는지 공유합니다.\n\n*세션 대상 : 재사용성이 높은 디자인 결과물을 빌드업 하는 경험을 원하는 예비 디자이너, 개발자와 디자이너로서 디자인 시스템이 무엇인지 알게되었고, 이것을 만들어 볼 시도를 원하시는 분',
        youtubeURL: 'https://www.youtube.com/embed/JlS2YXGjDxM',
        thumbnailImage: Design_Soo,
        externalLink: {
          url: 'https://github.com/yourssu/YDS-iOS',
          image: Github,
          title: 'YDS Repository',
          description: 'GitHub에서 보기',
        }
      },
    ],
  },
  {
    icon: '🛠',
    name: 'Engineering',
    id: 'Engineer',
    title: ['유어슈', '개발팀', '이 일하는 법'],
    description: '유어슈 소프트웨어 엔지니어들이 기본적인 이론과 최신 트랜드, 그리고 문제 해결을 위한 라이브러리 개발 경험을 공유합니다. 또한 개발자와 프로덕트 팀이 어떻게 협업하는지에 대한 프로세스 및 노하우를 공유합니다.',
    color: '#2C9DFF',
    date: null,
    iconUrl: Engineer,
    sessions: [
      {
        title: 'TF에서 개발자가 소통하는법',
        speakers: [{
          name: '배현빈',
          job: 'Engineering Leader',
          image: harry,
          email: 'harry.urssu@gmail.com',
        }],
        description:
          'COVID19로 인해 비대면 시대는 2년을 관통하고 있지만, 유어슈의 엔지니어링 팀 인원은 계속해서 증가되어왔고 해야할 일은 많아졌으며 더 높은 난이도 리소스를 요구하게 되었습니다.\n유어슈 엔지니어링팀이 이러한 요구와 동시에 서비스 개발의 속도는 증대시키면서 퀄리티를 유지하기 위해 시도했던 TF팀 프로세스에 대한 소개와 앞으로의 도전과제 및 한계를 공유하고자합니다.\n\n*세션 대상 : 작은 개발 동아리 혹은 그룹 인원이 늘어나면서 이를 효율적으로 관리하고 싶은 팀 리더, 팀간의 효율적인 프로세스로 더 나은 생산성을 고려하고싶은 개발자',
        youtubeURL: 'https://www.youtube.com/embed/rj4Z7aREZOI',
        thumbnailImage: Engineer_Harry,
      },
      {
        title: '의존성 주입과 Hilt 소개',
        speakers: [{
          name: '이승현',
          job: 'Android Engineer',
          image: peter,
          email: 'peter.urssu@gmail.com',
        }],
        description:
          '의존 관계(dependency)라는 개념을 들어보셨나요? 객체지향 설계 원칙인 SOLID 원칙 중에는 의존관계 역전 원칙이라는게 있습니다. 이 세션에서는 의존 관계에 대해 이야기 해보고자 합니다. 유어슈 안드로이드 팀에서 의존 관계 관리를 위해 사용하고있는 의존성 주입 라이브러리인 Hilt의 사용법도 간략하게 소개합니다.\n\n*세션 대상 : 학교에서 배운 객체지향 수업외에 더 실질적인 이론을 공부하고 싶으신 분, Android의 최신 트렌드이자 기본을 팔로업 하고 싶으신 분.',
        youtubeURL: 'https://www.youtube.com/embed/wZn-zpwvxCU',
        thumbnailImage: Engineer_Peter,
      },
      {
        title: '디자인시스템으로 한 번 짠 코드 백 번 써먹기',
        speakers: [
          {
            name: '김윤서',
            job: 'iOS Engineer',
            image: ezi,
            email: 'ezi.urssu@gmail.com',
          },{
            name: '김봉균',
            job: 'iOS Engineer',
            image: gyuni,
            email: 'gyuni.urssu@gmail.com',
          },
        ],
        description:
          'iOS 개발과정에서 스토리보드를 이용해 체계 없이 뷰를 작성하던 시절의 문제점을 회상하고, 이를 해결하기 위해 코드로 오토레이아웃을 작성하여 Yourssu Design System(이하 YDS)을 구현해 사용하고 있는 경험을 공유합니다. 이어 YDS를 이용해 얼마나 빠르게 서비스를 개발 할 수 있는지 예시를 들어 설명합니다.\n\n*세션 대상 : iOS 개발을 배웠지만 더 효율적으로 뷰를 관리하고, 재사용성을 높이는 구조로 프로젝트를 진행해보고 싶은 분, 디자인 세션의 YDS를 들었지만 그것이 실제 코드로 어떻게 구현되는지 궁금하신 분.',
        youtubeURL: 'https://www.youtube.com/embed/HyGASyJQ22g',
        thumbnailImage: Engineer_EziGyuni,
        externalLink: {
          url: 'https://github.com/yourssu/YDS-iOS',
          image: Github,
          title: 'YDS Repository',
          description: 'GitHub에서 보기',
        }
      },
    ],
  },
  {
    icon: '📦',
    name: 'Product',
    id: 'Product',
    title: ['유어슈에서', '서비스', '만들기'],
    description: '학생의, 학생에 의한, 학생을 위한 서비스 아이템은 어떤 과정을 통해 탄생할까요? 캠퍼스 커뮤니티라는 롱텀 서비스를 구성하는 방법과 아이덴티티 캐릭터를 중심으로 숏텀 이벤트 서비스를 만들어본 경험을 공유합니다.',
    color: '#F85F08',
    date: '11월 7일 오픈',
    iconUrl: Product,
    sessions: [
      {
        title: '2021 유어슈는 뭘 했을까?',
        speakers: [{
          name: '한도협',
          job: 'Head Leader',
          image: dino,
          email: 'dinohan.urssu@gmail.com',
        }],
        description:
          '최근 1년동안의 유어슈에 대한 전반적인 구성, 프로세스를 설명하는 세션입니다.\n유어슈의 구성원이 되어가는 과정, 필요한 경험치를 채우는 과정인 온보딩 개념을 설명하고, 그럼에도 존재하는 캠퍼스 커뮤니티 서비스 개발 동아리인 유어슈의 한계를 어떻게 좀 더 완화했는지에 대한 특급 비기를 최초로 공유합니다.\n\n*세션 대상 : 학생으로만 구성된 SW 프로덕트 팀을 어떻게 워킹하게할지 고민하는 분들, IT / 인터넷 회사의 매니징을 장기적인 목표로 삼는 학생들.',
        youtubeURL: 'https://www.youtube.com/embed/giRIpadaxD4',
        thumbnailImage: Product_Dino,
        externalLink: {
          url: 'https://apply.yourssu.com/',
          title: 'YOURSSU Recruit',
          description: '지원하기',
          image: YOURSSU,
        },
      },
      {
        title: '우당탕탕 뿌슝이 여정기',
        speakers: [{
          name: '이시은',
          job: 'Product Designer',
          image: joeum,
          email: 'joeum.urssu@gmail.com',
        }],
        description:
          '뿌슝이 테스트, 점뿌 해 본 사람!\n숭대생에게 사랑받는 뿌슝이 프로덕트 제작과정과 숫자로 표현된 성과를 공유합니다. 캠퍼스 커뮤니티의 유저 아이덴티티를 캐릭터로 표현하여 그것을 서비스화 브랜드화 시켜본 경험에 대해서도 알려드릴게요!\n\n*세션 대상 : IT/인터넷 회사의 PM / PO를 목표로 하는 학생들, 서비스의 기능을 넘어 브랜딩 전략에 대해서도 고민하고 시도해보고 싶은 학생들.',
        youtubeURL: 'https://www.youtube.com/embed/jPuuzk_lzWY',
        thumbnailImage: Product_Joeum,
        externalLink: {
          url: 'https://jumppu.yourssu.com/',
          title: '점수를 뿌시자!',
          description: '플레이 하러가기',
          image: PPUSSUNG,
        },
      },
    ],
  },
  {
    icon: '🏢',
    name: 'Career',
    id: 'Career',
    title: ['유어슈', '졸업생', '의 썰풀기'],
    description: '유어슈에서 경험을 쌓은 멤버들이 졸업 후 좋은 기회를 잡을 수 있었던 비결은 무엇일까요? 유어슈 졸업생들이 자신의 경쟁력을 빌드업한 방법과 졸업 이후를 어떻게 대비했는지를 공유합니다.',
    color: '#15CC05',
    date: '11월 7일 오픈',
    iconUrl: Career,
    sessions: [
      {
        title: '빠르게 변화하는 단체에서 살아남는 개발방법은 무엇일까',
        speakers: [{
          name: '박정현',
          job: 'Graduated Android Engineer',
          image: mint,
          email: 'parkmint.urssu@gmail.com',
        }],
        description:
          '학생들이 모인 개발팀에서 프러덕트를 만들어나가는 일은 한정적인 시간, 경험의 부족, 지속되는 기술적 결정의 번복 등 많은 면에서 어려움을 겪게합니다. 이 세션에서는 위와같은 문제를 진단하고 예비 개발자가 시도할 수 있는 기술적인 고민이 무엇인지, 어떻게 개발팀에 좋은 영향을 줄수있는지에 대한 실제 경험을 공유합니다.\n\n*세션 대상 : 좋은 개발자로 첫 커리어를 시작하고싶은 예비 개발자들, 학교에서 기초적인 CS 전공지식과 특정한 기술분야를 습득했지만 이것을 어떻게 더 갈고닦아야할지 방법을 찾고있는 예비 개발자들.',
        youtubeURL: 'https://www.youtube.com/embed/Lgs8YagZg7o',
        thumbnailImage: Career_Mint,
      },
      {
        title: '제로투 12',
        speakers: [{
          name: '한상준',
          job: 'Graduated iOS Engineer',
          image: andrew,
          email: 'andrew.urssu@gmail.com',
        }],
        description:
          '1인 솔로팀이었던 iOS 개발자 Andrew가 12명의 멤버로 이루어진 팀으로 성장시킨 비화를 공유합니다.\n팀의 목표와 개인의 목표, 개개인마다 다른 엔지니어링 역량등을 기준으로 어떻게 팀을 성장시키고 리드했는지에 대한 내용을 알아봅니다.\n\n*세션 대상 : iOS 개발을 몰라도 이해하는게 가능. 혼자서 공부하고 만드는 것보다 다수의 멤버와 함께 성장하기를 바라는 예비 개발자 및 동아리 개발 리더.',
        youtubeURL: 'https://www.youtube.com/embed/lgPeDEKz7CI',
        thumbnailImage: Career_Andrew,
      },
      {
        title: '취준생라이프 시작과 끝',
        speakers: [{
          name: '박상은',
          job: 'Graduated Backend Engineer',
          image: ashley,
          email: 'ashley.urssu@gmail.com',
        }],
        description: '평범한 컴퓨터 공학과에서 제공하는 커리큘럼을 따라가고 적당한 스터디에 참여해봤던 유어슈의 백엔드 개발자 애슐리가 어떤 기술스택을 고를지부터 구직의 순간까지의 과정 이야기를 전달합니다.\n나에게 맞는 회사의 종류가 어떤것인지, 어디에서 개발역량을 쌓아야하는지, 인턴은 어떻게 준비하는지와 정규직 채용 프로세스등에 대한 대부분의 학부생들이 궁금해할 내용에 대한 답을 이 세션에서 얻을 수 있습니다.\n\n*세션 대상 : 학교에서 제공하는 커리큘럼은 열심히 따르고 있지만, 구직 계획이 잘 세워지지 않고 막막함을 느끼는 예비 개발자.',
        youtubeURL: 'https://www.youtube.com/embed/ccFZDAeMP9Y',
        thumbnailImage: Career_Ashley,
      },
    ],
  },
];

export default List;
